<div
  class="subscription-drawer-open tw-fixed tw-inset-0 tw-z-50 tw-flex lgx:tw-justify-end"
  *ngIf="isOpen"
  tourAnchor="people-drawer"
  [@overlayAnimation]>
  <!-- Backdrop -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-black/50 dark:tw-bg-black/70"
    (click)="dismiss()"
    [@backdropAnimation]></div>

  <!-- Drawer Content -->
  <div
    class="tw-relative tw-w-full tw-max-w-6xl tw-bg-white tw-shadow-lg tw-shadow-gray-700 dark:tw-shadow-gray-600 tw-flex tw-flex-col tw-border-l tw-border-gray-200 dark:tw-bg-gray-900 tw-p-4 tw-pb-0"
    [@drawerAnimation]
    role="dialog"
    aria-modal="true">
    <!-- header -->
    <div
      class="subscribe-drawer-header tw-flex tw-justify-between tw-items-center tw-text-gray-800 dark:tw-text-gray-200">
      <div>
        <h2 class="tw-font-semibold tw-text-lg tw-my-1">
          {{ mode === 'data-selection' ? 'Download Options' : title }}
        </h2>
        <p
          *ngIf="mode === 'data-selection'"
          class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-mt-1">
          Selected: {{ title }}
        </p>
      </div>
      <button mat-icon-button (click)="dismiss()" aria-label="Close drawer">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- STEP 1: Filters -->
    <div *ngIf="mode=='filters'" class="tw-flex-1 tw-overflow-y-auto">
      <app-filters
        [setQuickBuild]="quickBuild"
        embedded="true"
        (searchCountChange)="matchingRecords = $event"></app-filters>
    </div>

    <!-- STEP 2: Data Selection -->
    <div *ngIf="mode=='data-selection'" class="tw-flex-1 tw-overflow-y-auto">
      <!-- available credits -->
      <div class="tw-mb-6">
        <div class="tw-ml-1 tw-mt-2">
          <app-credit-usage-indicator
            [displayMode]="'inline'"
            [pendingRecords]="matchingRecords"
            tourAnchor="people-credits"></app-credit-usage-indicator>
        </div>

        <!-- Credit limit alerts -->
        <div class="tw-mt-4" *ngIf="downloadLimit !== null && downloadLimit !== undefined">
          <!-- When user has enough credits -->
          <app-alert
            *ngIf="downloadLimit > matchingRecords"
            [alertType]="alertType.Info"
            alertStyle="compact"
            [hasBorder]="false"
            [noBottomMargin]="true">
            <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-2">
              <span class="tw-text-sm sm:tw-text-base">
                After this download, you will have
                <span class="tw-font-semibold">{{ downloadLimit - matchingRecords }}</span> credits
                remaining.
              </span>
              <button (click)="openUpgradeModal()" mat-stroked-button class="tw-flex-shrink-0">
                Manage Plan
              </button>
            </div>
          </app-alert>

          <!-- When user has some credits but not enough -->
          <app-alert
            *ngIf="downloadLimit < matchingRecords && downloadLimit > 0"
            [alertType]="alertType.Warning"
            alertStyle="compact"
            [hasBorder]="false"
            [noBottomMargin]="true">
            <div class="tw-flex tw-items-center tw-flex-wrap tw-gap-2">
              <span>
                You can only download <span class="tw-font-semibold">{{ downloadLimit }}</span> of
                the <span class="tw-font-semibold">{{ matchingRecords }}</span> records you have
                selected based on your current plan.
              </span>
              <button
                (click)="openUpgradeModal()"
                mat-stroked-button
                color="primary"
                class="tw-flex-shrink-0">
                Upgrade Plan
              </button>
            </div>
          </app-alert>

          <!-- When user has no credits left -->
          <app-alert
            *ngIf="downloadLimit === 0"
            [alertType]="alertType.Error"
            alertStyle="compact"
            [hasBorder]="false"
            [noBottomMargin]="true">
            <div class="tw-flex tw-items-center tw-flex-wrap  tw-gap-2">
              <span class="tw-font-medium"> You have reached your credit limit. </span>
              <button
                (click)="openUpgradeModal()"
                mat-stroked-button
                color="primary"
                class="tw-flex-shrink-0">
                Upgrade Plan
              </button>
            </div>
          </app-alert>
        </div>
      </div>

      <div class="tw-space-y-6 tw-mb-4 tw-ml-1 tw-mt-2">
        <!-- Download Option -->
        <div class="tw-flex tw-items-start">
          <!-- File Format Selection -->
          <div class="tw-mt-4">
            <app-download-format-matrix
              [formats]="formats"
              [selectedFormat]="selectedFormat"
              (onFormatSelect)="selectFormat($event)">
            </app-download-format-matrix>
          </div>
        </div>
      </div>

      <!-- Warning message when no options selected -->
      <app-alert
        *ngIf="!hasSelectedOption()"
        [alertType]="alertType.Warning"
        [closeable]="true"
        class="tw-mb-6"
        [hasBorder]="false">
        <div class="tw-text-sm">Please select at least one option to continue.</div>
      </app-alert>
    </div>

    <!-- Sticky Footer -->
    <div
      class="tw-p-4 tw-bg-white dark:tw-bg-gray-900 tw-flex tw-shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.2)] dark:tw-shadow-[0_-4px_6px_-1px_rgba(68,68,68,0.3)] tw-relative tw-mt-1 -tw-mx-4"
      [ngClass]="{'tw-justify-between': mode=='data-selection', 'tw-justify-center': mode=='filters'}">
      <!-- Back button (only visible in data-selection mode) -->
      <button *ngIf="mode=='data-selection'" mat-button (click)="goBack()">
        <span class="tw-flex tw-items-center tw-gap-2 tw-font-semibold">
          <mat-icon class="tw-text">arrow_back</mat-icon>
          <span>Back to Filters</span>
        </span>
      </button>

      <!-- Continue/Finalize button -->
      <button
        class="tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5"
        [disabled]="(mode=='data-selection' && !hasSelectedOption()) || (mode=='data-selection' && (!matchingRecords || matchingRecords <= 0) || downloadLimit === 0)"
        [ngClass]="{'tw-opacity-50 tw-cursor-not-allowed': (mode=='data-selection' && !hasSelectedOption()) || (mode=='data-selection' && (!matchingRecords || matchingRecords <= 0) || downloadLimit === 0)}"
        [matTooltip]="getTooltipMessage()"
        matTooltipPosition="above"
        [matTooltipDisabled]="!isButtonDisabled()"
        (click)="finalize()">
        <span class="tw-relative tw-px-5 tw-py-2 tw-rounded-md tw-font-semibold">
          <ng-container *ngIf="mode=='filters'"> Continue to Download Options </ng-container>
          <ng-container *ngIf="mode=='data-selection'"> Download Data </ng-container>
        </span>
      </button>
    </div>
  </div>
</div>
